import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ContentCardProps {
  article: Article;
  size?: 'normal' | 'large';
}

export default function ContentCard({ article, size = 'normal' }: ContentCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`relative overflow-hidden rounded-lg ${size === 'large' ? 'aspect-[16/9]' : 'aspect-[2/3]'}`}>
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          {size === 'large' && (
            <span className="inline-block px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md mb-2 whitespace-nowrap">
              {article.category}
            </span>
          )}
          <h3 className="text-background-50 font-heading font-semibold text-sm md:text-base line-clamp-2 group-hover:text-primary-300 transition-colors">
            {article.title}
          </h3>
          {size === 'large' && (
            <p className="text-foreground-300 text-xs mt-1 line-clamp-2 hidden sm:block">{article.description}</p>
          )}
        </div>
        {article.rating > 0 && (
          <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-md whitespace-nowrap">
            {article.rating}
          </div>
        )}
      </div>
      {size === 'normal' && (
        <div className="mt-2 px-0.5">
          <h4 className="text-foreground-900 font-medium text-sm line-clamp-1 group-hover:text-primary-500 transition-colors">
            {article.title}
          </h4>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-500">{article.year}</span>
            <span className="text-xs text-foreground-400">|</span>
            <span className="text-xs text-foreground-500">{article.category}</span>
          </div>
        </div>
      )}
    </Link>
  );
}